/**
 * EmptyStateFiltered
 *
 * Empty state displayed when a filter is applied but returns no results.
 * Shows a simple message indicating no athletes match the selected filter criteria.
 *
 * @component
 * @param {string} filterMessage - Custom message describing the filter (e.g., "this group")
 */
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../shared/images/teambuildr-selection.json';

const Container = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 64px;
  gap: 24px;
  width: 100%;
  min-height: 400px;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #EEEEEE;
`;

const IconContainer = styled('div')`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F5F5F5;
  border-radius: 50%;
`;

const TextContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  max-width: 500px;
`;

const Title = styled('h2')`
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 150%;
  text-align: center;
  color: #444444;
  margin: 0;
`;

const Description = styled('p')`
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #9E9E9E;
  margin: 0;
`;

const EmptyStateFiltered = ({ filterMessage }) => (
  <Container>
    <IconContainer>
      <IcomoonReact
        iconSet={iconSet}
        color='#9E9E9E'
        size={48}
        icon='gs-group'
      />
    </IconContainer>
    <TextContainer>
      <Title>No Athletes Found</Title>
      <Description>
        There are no athletes
        {' '}
        {filterMessage}
        . Try selecting a different group
        or add athletes
        {' '}
        {filterMessage}
        .
      </Description>
    </TextContainer>
  </Container>
);

EmptyStateFiltered.propTypes = {
  filterMessage: PropTypes.string,
};

EmptyStateFiltered.defaultProps = {
  filterMessage: 'matching this filter',
};

export default EmptyStateFiltered;
